export default __webpack_public_path__ + "static/anuPrasad1-b78d69459feb7810bc6a52f966443f44.jpg";